import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import AppFooter from '../../Components/AppFooter'

const Errorpage = () => {
  const navigate = useNavigate()

  const handlePreviousPage = () => {
    navigate(-1)
  }

  return (
    <section className="nx-app-bg flex min-h-screen w-full flex-col px-6 pb-4">
      <div className="flex flex-1 items-center justify-center py-6">
        <div className="nx-panel max-w-lg p-8 text-center">
        <p className="nx-manifest-kicker justify-center">404</p>
        <h1 className="mt-3 font-display text-4xl tracking-wide text-paper">Page not found</h1>
        <p className="mt-3 text-sm text-muted">
          That route is not on the Nexus V2 manifest. Check the URL or return to a known workspace.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <button type="button" onClick={handlePreviousPage} className="nx-btn-secondary">
            Go back
          </button>
          <Link to="/home" className="nx-btn-primary">
            Take me home
          </Link>
        </div>
      </div>
      </div>
      <AppFooter className="mx-auto w-full max-w-7xl" />
    </section>
  )
}

export default Errorpage
